// src/components/NavBar.js
import React from 'react';
import { Link } from 'react-router-dom';
import { signOut } from 'firebase/auth';
import { auth } from '../firebaseConfig';
import { useAuth } from '../AuthProvider'; // Make sure you have an AuthProvider set up

function NavBar() {
    const { user } = useAuth();

    const handleLogout = async () => {
        try {
            await signOut(auth);
            console.log("User signed out successfully");
        } catch (error) {
            console.error("Error signing out:", error);
        }
    };

    return (
        <nav>
            <div className="navbar">
                <div className="nav-link">
                    <Link to="/">Home</Link>
                </div>
                <div className="nav-link">
                    <Link to="/about">About</Link>
                </div>

                <div className="nav-link">
                    <Link
                        target="_blank"
                        rel="noopener noreferrer"
                        to="https://apparel.lukelittlechief.com"
                    >
                        Store
                    </Link>
                </div>
                <div className="nav-link">
                    <Link to="/EventList">Events</Link>
                </div>
                <div className="nav-link">
                    <Link to="/gallery">Gallery</Link>
                </div>
                {user && (
                    <>
                        <div className="nav-link">
                            <Link to="/CreateEvent">Create Event</Link>
                        </div>
                        <div className="nav-link">
                            <Link to="/UploadMedia">Upload Media</Link>
                        </div>
                        <div className="nav-link">
                            <button onClick={handleLogout}>Logout</button>
                        </div>
                    </>
                )}
            </div>
        </nav>
    );
}

export default NavBar;
